const { DataServiceEndPoint } = require("@cloudbreakus/network-utilities")

class EMR extends DataServiceEndPoint {
  static key = "EMR"

  static AVAILABLE_EVENTS = [
    "Epic.Video.AuthSuccess",
    "Epic.Video.AuthFailure",
    "Epic.Video.Connected",
    "Epic.Video.ParticipantUpdate",
    "Epic.Video.Disconnected",
    "Epic.Video.WaitingForAdmission",
    "KeepAlive",
    "Opened",
    "Closed",
  ]

  async handleEvent({ event, payload, interactionId, taskId, agentId }) {
    if (!EMR.AVAILABLE_EVENTS.includes(event)) {
      throw new Error(`unsupported EMR event: ${event}`, event)
    }

    await this._httpService.post(
      `${this.url}/v1/emr-events`,
      {
        event,
        payload: this.maybeStringifyPayload(payload),
        interactionId,
        taskId,
        agentId,
      },
      {
        headers: { Authorization: `bearer ${this.token}` },
        throttle: {
          maxCalls: 10
        }
      }
    )
  }

  maybeStringifyPayload(payload) {
    if (!payload || typeof payload === "string") {
      return payload
    }

    return JSON.stringify(payload)
  }
}

module.exports = EMR
